import type { ReactElement } from "react";

import { cx, styled } from "simplydo/react/styled";
import { Icon, type LucideIconData } from "simplydo/react/ui/icon";

import { StyledDropdownHeader } from "./Dropdown.styles";
import type { DropdownHeaderProps } from "./Dropdown.types";

const DropdownHeaderComponent = (props: DropdownHeaderProps): ReactElement => {
  const { children, className, icon, style } = props;

  return (
    <StyledDropdownHeader className={cx(className)} style={style}>
      {icon &&
      typeof icon === "object" &&
      !Array.isArray(icon) &&
      "node" in icon ? (
        <Icon icon={icon as LucideIconData} />
      ) : (
        icon
      )}
      {children}
    </StyledDropdownHeader>
  );
};

export const DropdownHeader = styled(DropdownHeaderComponent)``;
